import _classCallCheck from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/1800Flowers/apps/ui/mbp/mbp-pwa-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
var defaultMakeData = function defaultMakeData() {
  return Object.create(null);
};
// Useful for processing arguments objects as well as arrays.
var _Array$prototype = Array.prototype,
  forEach = _Array$prototype.forEach,
  slice = _Array$prototype.slice;
var hasOwnProperty = Object.prototype.hasOwnProperty;
export var Trie = /*#__PURE__*/function () {
  function Trie() {
    var weakness = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var makeData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMakeData;
    _classCallCheck(this, Trie);
    this.weakness = weakness;
    this.makeData = makeData;
  }
  return _createClass(Trie, [{
    key: "lookup",
    value: function lookup() {
      return this.lookupArray(arguments);
    }
  }, {
    key: "lookupArray",
    value: function lookupArray(array) {
      var node = this;
      forEach.call(array, function (key) {
        return node = node.getChildTrie(key);
      });
      return hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData(slice.call(array));
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.peekArray(arguments);
    }
  }, {
    key: "peekArray",
    value: function peekArray(array) {
      var node = this;
      for (var i = 0, len = array.length; node && i < len; ++i) {
        var map = node.mapFor(array[i], false);
        node = map && map.get(array[i]);
      }
      return node && node.data;
    }
  }, {
    key: "remove",
    value: function remove() {
      return this.removeArray(arguments);
    }
  }, {
    key: "removeArray",
    value: function removeArray(array) {
      var data;
      if (array.length) {
        var head = array[0];
        var map = this.mapFor(head, false);
        var child = map && map.get(head);
        if (child) {
          data = child.removeArray(slice.call(array, 1));
          if (!child.data && !child.weak && !(child.strong && child.strong.size)) {
            map.delete(head);
          }
        }
      } else {
        data = this.data;
        delete this.data;
      }
      return data;
    }
  }, {
    key: "getChildTrie",
    value: function getChildTrie(key) {
      var map = this.mapFor(key, true);
      var child = map.get(key);
      if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
      return child;
    }
  }, {
    key: "mapFor",
    value: function mapFor(key, create) {
      return this.weakness && isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap() : void 0) : this.strong || (create ? this.strong = new Map() : void 0);
    }
  }]);
}();
function isObjRef(value) {
  switch (typeof value) {
    case "object":
      if (value === null) break;
    // Fall through to return true...
    case "function":
      return true;
  }
  return false;
}